import Vue from 'vue'
import configs from '@/config'

let resource = null
// NOTE: seperate 2 type of api:
// + api: personal folder
// + api: for team folder
const actions = {
  getFolders: { // get all parent folders
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/`,
  },
  getShareFolders: { // get all parent folders
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/share`,
  },
  getFullFolderTree: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/get-full-folder-tree`,
  },
  getEditableFolderTrees: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/editable-folder-trees`,
  },
  createFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/folder`,
  },
  updateFolderById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
  removeFolderById: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
  addFolderCollaborators: {
    method: 'POST',
    url: `${configs.baseUrl}/api/folder/{folderId}/collaborators`,
  },
  getFolderCollaborators: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/{folderId}/collaborators`,
  },
  removeFolderCollaborators: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/folder/{folderId}/collaborators`,
  },
  leaveFolderCollaborators: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/folder/{folderId}/collaborators/leave`,
  },
  changeFolderCollaboratorRole: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/folder/{folderId}/collaborators/`,
  },
  // Team:
  getTeamFolders: {
    method: 'GET',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder`,
  },
  createTeamFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder`,
  },
  editTeamFolderById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder/{folderId}`,
  },
  removeTeamFolderById: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder/{folderId}`,
  },
  moveTeamPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/presentation/move-to-folder`,
  },
  // Sub-folders
  getSubFolders: { // get all child's folders
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/{parentFolderId}`,
  },
  createSubFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/folder/`,
  },
  getShareSubFolders: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/{parentFolderId}/get-share-sub-folders`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFolders = async (params) => { // get parent folders
  const res = await resource.getFolders(params)
  return res.body.folders
}
const getShareFolders = async (params) => { // get parent folders
  const res = await resource.getShareFolders(params)
  return res.body.folders
}
const getFullFolderTree = async () => {
  const res = await resource.getFullFolderTree()
  return res.body
}
const getEditableFolderTrees = async () => {
  const res = await resource.getEditableFolderTrees()
  return res.body.folderTrees
}

const createFolder = async (params) => {
  const res = await resource.createFolder(params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

const updateFolderById = (folderId, params) => {
  return resource.updateFolderById({ folderId }, params)
}

const removeFolderById = async (folderId) => {
  const res = await resource.removeFolderById({ folderId })
  return {
    deletedFolderIds: res.body.deletedIds.deletedFolderIds,
    deletedPresentationIds: res.body.deletedIds.deletedPresentationIds,
  }
}

const addFolderCollaborators = async (folderId, params) => {
  const res = await resource.addFolderCollaborators({ folderId }, params)
  return res.body
}

const removeFolderCollaborators = async (folderId, params) => {
  const res = await resource.removeFolderCollaborators({ folderId }, params)
  return res.body
}
const leaveFolderCollaborators = async (folderId, params) => {
  const res = await resource.leaveFolderCollaborators({ folderId }, params)
  return res.body
}

const getFolderCollaborators = async (folderId, params) => {
  const res = await resource.getFolderCollaborators({ folderId }, params)
  return res.body
}

const changeFolderCollaboratorRole = async (folderId, params) => {
  const res = await resource.changeFolderCollaboratorRole({ folderId }, params)
  return res.body
}

// Team Folder..
const getTeamFolders = async (params) => {
  const { accountId } = params
  const result = await resource.getTeamFolders({ accountId }, params)
  return result.body.folders
}

const createTeamFolder = async (accountId, params) => {
  const res = await resource.createTeamFolder({ accountId }, params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

const editTeamFolderById = async (accountId, folderId, params) => {
  const res = await resource.editTeamFolderById({ accountId, folderId }, params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}
const removeTeamFolderById = async (accountId, folderId, params) => {
  const res = await resource.removeTeamFolderById({ accountId, folderId }, params)
  return res.body
}

const moveTeamPresentation = async (accountId, params) => {
  const res = await resource.moveTeamPresentation({ accountId }, params)
  return res.body
}

// Sub-folders
const getSubFolders = async (parentFolderId, params) => { // get child's folders
  const { sortOrder, sortColumn } = params
  const res = await resource.getSubFolders({ parentFolderId, sortOrder, sortColumn })
  return {
    folders: res.body.folders,
    breadcrumbs: res.body.breadcrumb,
    depth: res.body.depth,
    hasShared: res.body.hasShared,
    userId: res.body.userId,
    ownerId: res.body.ownerId,
    folderName: res.body.folderName,
  }
}
const getShareSubFolders = async (parentFolderId, params) => { // get child's folders
  const { sortOrder, sortColumn } = params
  const res = await resource.getShareSubFolders({ parentFolderId, sortOrder, sortColumn })
  return {
    folders: res.body.folders,
    breadcrumbs: res.body.breadcrumb,
    depth: res.body.depth,
    permissions: res.body.permissions,
    userId: res.body.userId,
    ownerId: res.body.ownerId,
    folderName: res.body.folderName,
  }
}

const createSubFolder = async (params) => {
  const res = await resource.createSubFolder(params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

export default {
  initResource,
  getFolders,
  getFullFolderTree,
  getEditableFolderTrees,
  createFolder,
  updateFolderById,
  removeFolderById,
  getTeamFolders,
  createTeamFolder,
  editTeamFolderById,
  removeTeamFolderById,
  moveTeamPresentation,
  addFolderCollaborators,
  getFolderCollaborators,
  removeFolderCollaborators,
  leaveFolderCollaborators,
  changeFolderCollaboratorRole,

  // sub-folders
  getSubFolders,
  createSubFolder,
  getShareFolders,
  getShareSubFolders,
}
